import { useSelector } from 'react-redux'

import StockInfo from 'Component/stock/info'
import EtfInfo from 'Component/etf/info'

import { useEffect, useState } from 'react';
import { getInfo } from 'Request/login';

const Info = () => {

  const { tickerDetail } = useSelector((state) => state.stock);

  const [user, setUser] = useState(null);
      useEffect(() => {
        getInfo()
          .then(res => {
            setUser(res);
            console.log("✅ 로그인된 사용자:", res);
          })
          .catch(() => {
            console.log("❌ 로그인 안됨");
          });
      }, []);

	return (
    <>
      { tickerDetail && tickerDetail.outline && tickerDetail.STK_TYP === 1 &&
        <StockInfo data={{ user_id: user?.data?.user_id, ...tickerDetail }} />
      }
      { tickerDetail && tickerDetail.outline && tickerDetail.STK_TYP === 2 && 
        <EtfInfo data={{ user_id: user?.data?.user_id, ...tickerDetail }} />
      }
    </>
  );
}

export default Info;
